import { Eye, Package } from 'lucide-react';
import '../accessoriesStyles/product-card.css';
import { ImageWithFallback } from './figma/ImageWithFallback.jsx';

export function ProductCard({ product, onQuickAdd, onViewDetails }) {
  const isComingSoon = product.comingSoon || !product.inStock;
  
  return (
    <div 
      className={`product-card ${isComingSoon ? 'coming-soon' : ''}`}
      onClick={() => onViewDetails(product)}
    >
      {/* Product Image */}
      <div className="product-card-image-container">
        <ImageWithFallback
          src={product.image}
          alt={product.name}
          className="product-card-image"
        />
        {/* Brand Tag */}
        <div className="product-card-brand-tag">
          {product.brand}
        </div>
        {/* Stock Badge */}
        <div className={`product-card-stock-badge ${isComingSoon ? 'coming-soon' : ''}`}>
          <Package className="product-card-stock-icon" />
          <span className="product-card-stock-text">
            {product.comingSoon ? 'Coming Soon' : product.inStock ? 'In Stock' : 'Out of Stock'}
          </span>
        </div>
      </div>

      {/* Product Info */}
      <div className="product-card-content">
        <div className="product-card-info">
          <p className="product-card-category">
            {product.category}
          </p>
          <h3 className="product-card-name">
            {product.name}
          </h3>
        </div>

        <div className="product-card-footer">
          <div className="product-card-price-container">
            {product.originalPrice && (
              <p className="product-card-original-price">
                ₹{product.originalPrice.toLocaleString('en-IN')}
              </p>
            )}
            <p className="product-card-price">
              ₹{product.price.toLocaleString('en-IN')}
            </p>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onViewDetails(product);
            }}
            className={`product-card-button ${isComingSoon ? 'disabled' : ''}`}
            disabled={isComingSoon}
          >
            <Eye className="product-card-button-icon" />
            {isComingSoon ? 'Coming Soon' : 'View'}
          </button>
        </div>
      </div>

      {/* Hover Overlay Effect */}
      <div className="product-card-hover-ring" />
    </div>
  );
}
